import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import React, { ReactNode } from 'react'
import { defaultTheme } from 'styles/themes/default-theme'

interface ICustomThemeProviderProps {
  children: ReactNode
}

const CustomThemeProvider: React.FC<ICustomThemeProviderProps> = ({ children }) => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}

export default CustomThemeProvider
